<template>
  <div class="image-wrapper" :style="style">
    <van-image
      width="100%"
      height="100%"
      :lazy-load="lazyLoad"
      :src="src"
      :fit="fit"
      :position="position"
      @load="imageLoad"
    >
      <template #loading>
        <Skeleton :style="style" />
      </template>
      <template #error>
        <img v-if="errorUrl" :src="errorUrl" alt="error" />
        <template v-else>
          <i class="van-badge__wrapper van-icon van-icon-photo-fail van-image__error-icon"></i>
          <span class="error-title van-ellipsis" v-if="title">{{ title }}</span>
        </template>
      </template>
    </van-image>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { isNaN, toNumber } from 'lodash-es';
import Skeleton from './skeleton.vue';

type Props = {
  ratio?: number | string;
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  fit?: 'cover' | 'contain' | 'fill' | 'none';
  position?: string;
  src?: string;
  lazyLoad?: boolean;
  title?: string;
  errorUrl?: string;
  // round?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  ratio: 'auto',
  width: '100%',
  height: '100%',
  radius: 0,
  fit: 'cover',
  position: 'center',
  lazyLoad: true,
  // round: false,
});

const emit = defineEmits<{
  (e: 'imageLoad'): void;
}>();

const style = computed(() => {
  return {
    aspectRatio: props.ratio,
    width: isNaN(toNumber(props.width)) ? props.width : `${props.width}${toNumber(props.width) > 0 ? 'px' : ''}`,
    height: isNaN(toNumber(props.height)) ? props.height : `${props.height}}${toNumber(props.height) > 0 ? 'px' : ''}`,
    borderRadius: isNaN(toNumber(props.radius))
      ? props.radius
      : `${props.radius}}${toNumber(props.radius) > 0 ? 'px' : ''}`,
  };
});

const imageLoad = () => {
  emit('imageLoad');
};
</script>

<style lang="less" scoped>
.image-wrapper {
  overflow: hidden;

  :deep(.van-image) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .error-title {
    position: absolute;
    bottom: 30px;
    max-width: 70%;
    color: #fff;
    font-size: 42px;
  }
}
</style>
